var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20Z",
    fill: "#3BF5CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.998 12.5H10.998C10.7991 12.5 10.6084 12.579 10.4677 12.7197C10.3271 12.8603 10.248 13.0511 10.248 13.25V26C10.248 26.3978 10.4061 26.7794 10.6874 27.0607C10.9687 27.342 11.3502 27.5 11.748 27.5H28.248C28.6459 27.5 29.0274 27.342 29.3087 27.0607C29.59 26.7794 29.748 26.3978 29.748 26V13.25C29.748 13.0511 29.669 12.8603 29.5284 12.7197C29.3877 12.579 29.197 12.5 28.998 12.5ZM28.248 26H11.748V14.9553L19.4909 22.0531C19.6292 22.1801 19.8102 22.2506 19.998 22.2506C20.1859 22.2506 20.3669 22.1801 20.5052 22.0531L28.248 14.9553V26Z",
    fill: "#052035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/Tw.d0ea2a2039982f8f36de17cb12a6d7fa.svg";
export { ForwardRef as ReactComponent };